{
  "version": 1,
  "asset_id": "8772e539-31f8-4385-9bfa-67528e726797",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/8772e539-31f8-4385-9bfa-67528e726797/ukrpa-logo.jpg",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/8772e539-31f8-4385-9bfa-67528e726797/ukrpa-logo.jpg",
  "original_filename": "ukrpa-logo.jpg",
  "size": 445455,
  "content_type": "image/jpeg",
  "created_at": "2026-11-03T14:41:36Z"
}
